
import {Component, Ref, Vue} from 'vue-property-decorator'
import AjandaInfo from "@/components/infos/AjandaInfo.vue";
import IsList from "@/components/lists/IsList.vue";
import IsSablonList from "@/components/lists/IsSablonList.vue";

@Component({
  components: {IsSablonList, IsList, AjandaInfo}
})
export default class AjandaView extends Vue {
  @Ref('isList') readonly isList!: IsList;
  @Ref('ajanda') readonly ajanda!: AjandaInfo;

  loadSablonPicker() {
    if (this.isList) {
      this.isList.loadSablon();
    }
  }

  loadAjanda() {
    if (this.ajanda) {
      this.ajanda.load();
    }
  }

  sablonYuklendi(sablonlar: any[]) {
    this.$nextTick(() => {
      this.loadAjanda();
    });
  }
}
